import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import QList from "../item/QList.js";
import QMarkupTable from "../markup-table/QMarkupTable.js";
import getTableMiddle from "../table/get-table-middle.js";
import VirtualScroll from "../../mixins/virtual-scroll.js";
import AttrsMixin from "../../mixins/attrs.js";
import ListenersMixin from "../../mixins/listeners.js";
import { getScrollTarget } from "../../utils/scroll.js";
import { listenOpts } from "../../utils/event.js";
import { mergeSlot } from "../../utils/slot.js";
var comps = {
  list: QList,
  table: QMarkupTable
};
export default Vue.extend({
  name: 'QVirtualScroll',
  mixins: [AttrsMixin, ListenersMixin, VirtualScroll],
  props: {
    type: {
      type: String,
      default: 'list',
      validator: function validator(v) {
        return ['list', 'table', '__qtable'].includes(v);
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemsFn: Function,
    itemsSize: Number,
    scrollTarget: {
      default: void 0
    }
  },
  computed: {
    virtualScrollLength: function virtualScrollLength() {
      return this.itemsSize >= 0 && this.itemsFn !== void 0 ? parseInt(this.itemsSize, 10) : Array.isArray(this.items) ? this.items.length : 0;
    },
    virtualScrollScope: function virtualScrollScope() {
      var _this = this;

      if (this.virtualScrollLength === 0) {
        return [];
      }

      var mapFn = function mapFn(item, i) {
        return {
          index: _this.virtualScrollSliceRange.from + i,
          item: item
        };
      };

      if (this.itemsFn === void 0) {
        return this.items.slice(this.virtualScrollSliceRange.from, this.virtualScrollSliceRange.to).map(mapFn);
      }

      return this.itemsFn(this.virtualScrollSliceRange.from, this.virtualScrollSliceRange.to - this.virtualScrollSliceRange.from).map(mapFn);
    },
    classes: function classes() {
      return 'q-virtual-scroll q-virtual-scroll' + (this.virtualScrollHorizontal === true ? '--horizontal' : '--vertical') + (this.scrollTarget !== void 0 ? '' : ' scroll');
    },
    attrs: function attrs() {
      return this.scrollTarget !== void 0 ? void 0 : {
        tabindex: 0
      };
    }
  },
  watch: {
    virtualScrollLength: function virtualScrollLength() {
      this.__resetVirtualScroll();
    },
    scrollTarget: function scrollTarget() {
      this.__unconfigureScrollTarget();

      this.__configureScrollTarget();
    }
  },
  methods: {
    __getVirtualScrollEl: function __getVirtualScrollEl() {
      return this.$el;
    },
    __getVirtualScrollTarget: function __getVirtualScrollTarget() {
      return this.__scrollTarget;
    },
    __configureScrollTarget: function __configureScrollTarget() {
      this.__scrollTarget = getScrollTarget(this.$el, this.scrollTarget);

      this.__scrollTarget.addEventListener('scroll', this.__onVirtualScrollEvt, listenOpts.passive);
    },
    __unconfigureScrollTarget: function __unconfigureScrollTarget() {
      if (this.__scrollTarget !== void 0) {
        this.__scrollTarget.removeEventListener('scroll', this.__onVirtualScrollEvt, listenOpts.passive);

        this.__scrollTarget = void 0;
      }
    }
  },
  beforeMount: function beforeMount() {
    this.__resetVirtualScroll();
  },
  mounted: function mounted() {
    this.__configureScrollTarget();
  },
  beforeDestroy: function beforeDestroy() {
    this.__unconfigureScrollTarget();
  },
  render: function render(h) {
    if (this.$scopedSlots.default === void 0) {
      console.error("QVirtualScroll: default scoped slot is required for rendering", this);
      return;
    }

    var child = this.__padVirtualScroll(h, this.type === 'list' ? 'div' : 'tbody', this.virtualScrollScope.map(this.$scopedSlots.default));

    if (this.$scopedSlots.before !== void 0) {
      child = this.$scopedSlots.before().concat(child);
    }

    child = mergeSlot(child, this, 'after');
    return this.type === '__qtable' ? getTableMiddle(h, {
      staticClass: this.classes
    }, child) : h(comps[this.type], {
      class: this.classes,
      attrs: this.attrs,
      props: this.qAttrs,
      on: _objectSpread({}, this.qListeners)
    }, child);
  }
});